import { render, staticRenderFns } from "./QuoteFormCarrier.vue?vue&type=template&id=ea698a18&scoped=true&"
import script from "./QuoteFormCarrier.vue?vue&type=script&lang=ts&"
export * from "./QuoteFormCarrier.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFormCarrier.vue?vue&type=style&index=0&id=ea698a18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea698a18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
